import Phaser from "phaser";
import { getMe, clearToken } from "../api";
import { FONT, UI } from "../types";
import { preloadUI } from "../ui";

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: "BootScene" });
  }

  preload(): void {
    preloadUI(this);

    // Loading progress bar
    const { width, height } = this.scale;
    const barBg = this.add.rectangle(width / 2, height / 2 + 20, 240, 14, 0x333333);
    const barFill = this.add.rectangle(width / 2 - 120, height / 2 + 20, 0, 12, 0xf5c242)
      .setOrigin(0, 0.5);
    this.add.text(width / 2, height / 2 - 30, "ImperiumGuardians", {
      fontFamily: FONT, fontSize: "26px", fontStyle: "bold", color: "#f5c242",
    }).setOrigin(0.5);
    const statusText = this.add.text(width / 2, height / 2 + 50, "Cargando assets...", {
      fontFamily: FONT, fontSize: "12px", color: UI.TEXT,
    }).setOrigin(0.5);

    this.load.on("progress", (p: number) => {
      barFill.width = 240 * p;
    });
    this.load.on("complete", () => {
      barBg.destroy(); barFill.destroy();
      statusText.setText("Conectando...");
    });
  }

  create(): void {
    this.checkAuth();
  }

  private async checkAuth(): Promise<void> {
    const token = localStorage.getItem("guardians_token");
    if (!token) {
      this.time.delayedCall(300, () => this.scene.start("AuthScene"));
      return;
    }
    try {
      const user = await getMe();
      if (user.has_chosen_creatures) {
        this.scene.start("MapScene");
      } else {
        this.scene.start("IntroScene");
      }
    } catch {
      clearToken();
      this.scene.start("AuthScene");
    }
  }
}
